import { useEffect, useMemo, useState } from 'react'
import './device-status.scss'
import feathers from 'utility/client'
import { deviceStatus } from '../constants'
import './indicator.scss'

export const Indicator = (props) => {
  const { device, ...otherProps } = props
  const [state, setState] = useState(props.state)

  const onDeviceUpdated = (device) => {
    if (device._id !== device) {
      return
    }
    setState(device.state)
  }

  const indicatorType = useMemo(() => {
    switch (state) {
      case deviceStatus.unknown:
        return 'dot dot-secondary'
      case deviceStatus.online:
        return 'dot dot-warning'
      case deviceStatus.live:
        return 'dot dot-success'
      case deviceStatus.offline:
        return 'dot dot-danger'
      default:
        return 'dot dot-secondary'
    }
  }, [state])

  useEffect(() => {
    feathers.service('device').on('patched', onDeviceUpdated)

    return () => {
      feathers.service('device').removeListener('patched', onDeviceUpdated)
    }
  }, [])

  useEffect(() => {
    setState(props.state)
  }, [props.state])

  return (
    <div {...otherProps}>
      <div className="dot-wrapper">
        <div className={indicatorType}></div>
      </div>
    </div>
  )
}
